/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiError,
  CollectResponse,
  GamificationModelResponse,
  JoinTeamBody,
  JoinTeamResponse,
  MySpinWheelConfigIdResponse,
  PredictionPickBody,
  PredictionPickResponse,
  PurchaseBody,
  PurchaseResponse,
  ShareGamificationModelBody,
  ShareGamificationModelResponse,
  ShowcaseSubmitBody,
  ShowcaseSubmitResponse,
  SolveBody,
  SolveResponse,
  SpinWheelConfigPublicResponse,
  TriviaAnswerBody,
  TriviaAnswerResponse,
  VoteBody,
  VoteResponse,
  WheelSpinResultResponse,
} from '../models/index';
import {
    ApiErrorFromJSON,
    ApiErrorToJSON,
    CollectResponseFromJSON,
    CollectResponseToJSON,
    GamificationModelResponseFromJSON,
    GamificationModelResponseToJSON,
    JoinTeamBodyFromJSON,
    JoinTeamBodyToJSON,
    JoinTeamResponseFromJSON,
    JoinTeamResponseToJSON,
    MySpinWheelConfigIdResponseFromJSON,
    MySpinWheelConfigIdResponseToJSON,
    PredictionPickBodyFromJSON,
    PredictionPickBodyToJSON,
    PredictionPickResponseFromJSON,
    PredictionPickResponseToJSON,
    PurchaseBodyFromJSON,
    PurchaseBodyToJSON,
    PurchaseResponseFromJSON,
    PurchaseResponseToJSON,
    ShareGamificationModelBodyFromJSON,
    ShareGamificationModelBodyToJSON,
    ShareGamificationModelResponseFromJSON,
    ShareGamificationModelResponseToJSON,
    ShowcaseSubmitBodyFromJSON,
    ShowcaseSubmitBodyToJSON,
    ShowcaseSubmitResponseFromJSON,
    ShowcaseSubmitResponseToJSON,
    SolveBodyFromJSON,
    SolveBodyToJSON,
    SolveResponseFromJSON,
    SolveResponseToJSON,
    SpinWheelConfigPublicResponseFromJSON,
    SpinWheelConfigPublicResponseToJSON,
    TriviaAnswerBodyFromJSON,
    TriviaAnswerBodyToJSON,
    TriviaAnswerResponseFromJSON,
    TriviaAnswerResponseToJSON,
    VoteBodyFromJSON,
    VoteBodyToJSON,
    VoteResponseFromJSON,
    VoteResponseToJSON,
    WheelSpinResultResponseFromJSON,
    WheelSpinResultResponseToJSON,
} from '../models/index';

export interface CreateGamificationModelsIdAnswerRequest {
    id: string;
    triviaAnswerBody: TriviaAnswerBody;
}

export interface CreateGamificationModelsIdCollectRequest {
    id: string;
}

export interface CreateGamificationModelsIdJoinTeamRequest {
    id: string;
    joinTeamBody: JoinTeamBody;
}

export interface CreateGamificationModelsIdPickRequest {
    id: string;
    predictionPickBody: PredictionPickBody;
}

export interface CreateGamificationModelsIdPurchaseRequest {
    id: string;
    purchaseBody: PurchaseBody;
}

export interface CreateGamificationModelsIdShareRequest {
    id: string;
    shareGamificationModelBody: ShareGamificationModelBody;
}

export interface CreateGamificationModelsIdSolveRequest {
    id: string;
    solveBody: SolveBody;
}

export interface CreateGamificationModelsIdSpinRequest {
    id: string;
}

export interface CreateGamificationModelsIdSubmitRequest {
    id: string;
    showcaseSubmitBody: ShowcaseSubmitBody;
}

export interface CreateGamificationModelsIdVoteRequest {
    id: string;
    voteBody: VoteBody;
}

export interface GetGamificationModelsIdRequest {
    id: string;
}

export interface GetGamificationModelsIdMySpinWheelConfigIdRequest {
    id: string;
}

export interface GetGamificationModelsSpinWheelConfigConfigIdRequest {
    configId: string;
}

/**
 * GamificationApi - interface
 * 
 * @export
 * @interface GamificationApiInterface
 */
export interface GamificationApiInterface {
    /**
     * Submit an answer to a question in a TRIVIA gamification model
     * @param {string} id 
     * @param {TriviaAnswerBody} triviaAnswerBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamificationApiInterface
     */
    createGamificationModelsIdAnswerRaw(requestParameters: CreateGamificationModelsIdAnswerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TriviaAnswerResponse>>;

    /**
     * Submit an answer to a question in a TRIVIA gamification model
     */
    createGamificationModelsIdAnswer(requestParameters: CreateGamificationModelsIdAnswerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TriviaAnswerResponse>;

    /**
     * Draw a random collectible item from a COLLECTION gamification model
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamificationApiInterface
     */
    createGamificationModelsIdCollectRaw(requestParameters: CreateGamificationModelsIdCollectRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CollectResponse>>;

    /**
     * Draw a random collectible item from a COLLECTION gamification model
     */
    createGamificationModelsIdCollect(requestParameters: CreateGamificationModelsIdCollectRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CollectResponse>;

    /**
     * Join Team A or B in a RIVALRY or TURF_WAR gamification model
     * @param {string} id 
     * @param {JoinTeamBody} joinTeamBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamificationApiInterface
     */
    createGamificationModelsIdJoinTeamRaw(requestParameters: CreateGamificationModelsIdJoinTeamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<JoinTeamResponse>>;

    /**
     * Join Team A or B in a RIVALRY or TURF_WAR gamification model
     */
    createGamificationModelsIdJoinTeam(requestParameters: CreateGamificationModelsIdJoinTeamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<JoinTeamResponse>;

    /**
     * Submit or update a prediction pick on a PREDICTIONS gamification model
     * @param {string} id 
     * @param {PredictionPickBody} predictionPickBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamificationApiInterface
     */
    createGamificationModelsIdPickRaw(requestParameters: CreateGamificationModelsIdPickRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PredictionPickResponse>>;

    /**
     * Submit or update a prediction pick on a PREDICTIONS gamification model
     */
    createGamificationModelsIdPick(requestParameters: CreateGamificationModelsIdPickRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PredictionPickResponse>;

    /**
     * Purchase an item from a MARKET gamification model
     * @param {string} id 
     * @param {PurchaseBody} purchaseBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamificationApiInterface
     */
    createGamificationModelsIdPurchaseRaw(requestParameters: CreateGamificationModelsIdPurchaseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PurchaseResponse>>;

    /**
     * Purchase an item from a MARKET gamification model
     */
    createGamificationModelsIdPurchase(requestParameters: CreateGamificationModelsIdPurchaseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PurchaseResponse>;

    /**
     * Track a share action for a gamification model and award XP
     * @param {string} id 
     * @param {ShareGamificationModelBody} shareGamificationModelBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamificationApiInterface
     */
    createGamificationModelsIdShareRaw(requestParameters: CreateGamificationModelsIdShareRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShareGamificationModelResponse>>;

    /**
     * Track a share action for a gamification model and award XP
     */
    createGamificationModelsIdShare(requestParameters: CreateGamificationModelsIdShareRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShareGamificationModelResponse>;

    /**
     * Submit a solution attempt for a CIPHER gamification model
     * @param {string} id 
     * @param {SolveBody} solveBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamificationApiInterface
     */
    createGamificationModelsIdSolveRaw(requestParameters: CreateGamificationModelsIdSolveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SolveResponse>>;

    /**
     * Submit a solution attempt for a CIPHER gamification model
     */
    createGamificationModelsIdSolve(requestParameters: CreateGamificationModelsIdSolveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SolveResponse>;

    /**
     * Spin on a WHEEL_SPIN or QUEST_ROULETTE gamification model
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamificationApiInterface
     */
    createGamificationModelsIdSpinRaw(requestParameters: CreateGamificationModelsIdSpinRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WheelSpinResultResponse>>;

    /**
     * Spin on a WHEEL_SPIN or QUEST_ROULETTE gamification model
     */
    createGamificationModelsIdSpin(requestParameters: CreateGamificationModelsIdSpinRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WheelSpinResultResponse>;

    /**
     * Submit an entry to a SHOWCASE gamification model
     * @param {string} id 
     * @param {ShowcaseSubmitBody} showcaseSubmitBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamificationApiInterface
     */
    createGamificationModelsIdSubmitRaw(requestParameters: CreateGamificationModelsIdSubmitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShowcaseSubmitResponse>>;

    /**
     * Submit an entry to a SHOWCASE gamification model
     */
    createGamificationModelsIdSubmit(requestParameters: CreateGamificationModelsIdSubmitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShowcaseSubmitResponse>;

    /**
     * Vote for an entry in a SHOWCASE or BRACKET_VOTE gamification model
     * @param {string} id 
     * @param {VoteBody} voteBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamificationApiInterface
     */
    createGamificationModelsIdVoteRaw(requestParameters: CreateGamificationModelsIdVoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VoteResponse>>;

    /**
     * Vote for an entry in a SHOWCASE or BRACKET_VOTE gamification model
     */
    createGamificationModelsIdVote(requestParameters: CreateGamificationModelsIdVoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VoteResponse>;

    /**
     * Get a gamification model (public — excludes DRAFT and ARCHIVED). Answers and unrevealed content are omitted.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamificationApiInterface
     */
    getGamificationModelsIdRaw(requestParameters: GetGamificationModelsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GamificationModelResponse>>;

    /**
     * Get a gamification model (public — excludes DRAFT and ARCHIVED). Answers and unrevealed content are omitted.
     */
    getGamificationModelsId(requestParameters: GetGamificationModelsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GamificationModelResponse>;

    /**
     * Resolve which spin wheel config the authenticated user will spin (routes prize-restricted users to the global wheel)
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamificationApiInterface
     */
    getGamificationModelsIdMySpinWheelConfigIdRaw(requestParameters: GetGamificationModelsIdMySpinWheelConfigIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MySpinWheelConfigIdResponse>>;

    /**
     * Resolve which spin wheel config the authenticated user will spin (routes prize-restricted users to the global wheel)
     */
    getGamificationModelsIdMySpinWheelConfigId(requestParameters: GetGamificationModelsIdMySpinWheelConfigIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MySpinWheelConfigIdResponse>;

    /**
     * Get public segment display data for a spin wheel config (no probabilities)
     * @param {string} configId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamificationApiInterface
     */
    getGamificationModelsSpinWheelConfigConfigIdRaw(requestParameters: GetGamificationModelsSpinWheelConfigConfigIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SpinWheelConfigPublicResponse>>;

    /**
     * Get public segment display data for a spin wheel config (no probabilities)
     */
    getGamificationModelsSpinWheelConfigConfigId(requestParameters: GetGamificationModelsSpinWheelConfigConfigIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SpinWheelConfigPublicResponse>;

}

/**
 * 
 */
export class GamificationApi extends runtime.BaseAPI implements GamificationApiInterface {

    /**
     * Submit an answer to a question in a TRIVIA gamification model
     */
    async createGamificationModelsIdAnswerRaw(requestParameters: CreateGamificationModelsIdAnswerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TriviaAnswerResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling createGamificationModelsIdAnswer().'
            );
        }

        if (requestParameters['triviaAnswerBody'] == null) {
            throw new runtime.RequiredError(
                'triviaAnswerBody',
                'Required parameter "triviaAnswerBody" was null or undefined when calling createGamificationModelsIdAnswer().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/gamification-models/{id}/answer`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TriviaAnswerBodyToJSON(requestParameters['triviaAnswerBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TriviaAnswerResponseFromJSON(jsonValue));
    }

    /**
     * Submit an answer to a question in a TRIVIA gamification model
     */
    async createGamificationModelsIdAnswer(requestParameters: CreateGamificationModelsIdAnswerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TriviaAnswerResponse> {
        const response = await this.createGamificationModelsIdAnswerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Draw a random collectible item from a COLLECTION gamification model
     */
    async createGamificationModelsIdCollectRaw(requestParameters: CreateGamificationModelsIdCollectRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CollectResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling createGamificationModelsIdCollect().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/gamification-models/{id}/collect`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CollectResponseFromJSON(jsonValue));
    }

    /**
     * Draw a random collectible item from a COLLECTION gamification model
     */
    async createGamificationModelsIdCollect(requestParameters: CreateGamificationModelsIdCollectRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CollectResponse> {
        const response = await this.createGamificationModelsIdCollectRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Join Team A or B in a RIVALRY or TURF_WAR gamification model
     */
    async createGamificationModelsIdJoinTeamRaw(requestParameters: CreateGamificationModelsIdJoinTeamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<JoinTeamResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling createGamificationModelsIdJoinTeam().'
            );
        }

        if (requestParameters['joinTeamBody'] == null) {
            throw new runtime.RequiredError(
                'joinTeamBody',
                'Required parameter "joinTeamBody" was null or undefined when calling createGamificationModelsIdJoinTeam().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/gamification-models/{id}/join-team`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: JoinTeamBodyToJSON(requestParameters['joinTeamBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => JoinTeamResponseFromJSON(jsonValue));
    }

    /**
     * Join Team A or B in a RIVALRY or TURF_WAR gamification model
     */
    async createGamificationModelsIdJoinTeam(requestParameters: CreateGamificationModelsIdJoinTeamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<JoinTeamResponse> {
        const response = await this.createGamificationModelsIdJoinTeamRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Submit or update a prediction pick on a PREDICTIONS gamification model
     */
    async createGamificationModelsIdPickRaw(requestParameters: CreateGamificationModelsIdPickRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PredictionPickResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling createGamificationModelsIdPick().'
            );
        }

        if (requestParameters['predictionPickBody'] == null) {
            throw new runtime.RequiredError(
                'predictionPickBody',
                'Required parameter "predictionPickBody" was null or undefined when calling createGamificationModelsIdPick().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/gamification-models/{id}/pick`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PredictionPickBodyToJSON(requestParameters['predictionPickBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PredictionPickResponseFromJSON(jsonValue));
    }

    /**
     * Submit or update a prediction pick on a PREDICTIONS gamification model
     */
    async createGamificationModelsIdPick(requestParameters: CreateGamificationModelsIdPickRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PredictionPickResponse> {
        const response = await this.createGamificationModelsIdPickRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Purchase an item from a MARKET gamification model
     */
    async createGamificationModelsIdPurchaseRaw(requestParameters: CreateGamificationModelsIdPurchaseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PurchaseResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling createGamificationModelsIdPurchase().'
            );
        }

        if (requestParameters['purchaseBody'] == null) {
            throw new runtime.RequiredError(
                'purchaseBody',
                'Required parameter "purchaseBody" was null or undefined when calling createGamificationModelsIdPurchase().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/gamification-models/{id}/purchase`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PurchaseBodyToJSON(requestParameters['purchaseBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PurchaseResponseFromJSON(jsonValue));
    }

    /**
     * Purchase an item from a MARKET gamification model
     */
    async createGamificationModelsIdPurchase(requestParameters: CreateGamificationModelsIdPurchaseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PurchaseResponse> {
        const response = await this.createGamificationModelsIdPurchaseRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Track a share action for a gamification model and award XP
     */
    async createGamificationModelsIdShareRaw(requestParameters: CreateGamificationModelsIdShareRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShareGamificationModelResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling createGamificationModelsIdShare().'
            );
        }

        if (requestParameters['shareGamificationModelBody'] == null) {
            throw new runtime.RequiredError(
                'shareGamificationModelBody',
                'Required parameter "shareGamificationModelBody" was null or undefined when calling createGamificationModelsIdShare().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/gamification-models/{id}/share`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ShareGamificationModelBodyToJSON(requestParameters['shareGamificationModelBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShareGamificationModelResponseFromJSON(jsonValue));
    }

    /**
     * Track a share action for a gamification model and award XP
     */
    async createGamificationModelsIdShare(requestParameters: CreateGamificationModelsIdShareRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShareGamificationModelResponse> {
        const response = await this.createGamificationModelsIdShareRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Submit a solution attempt for a CIPHER gamification model
     */
    async createGamificationModelsIdSolveRaw(requestParameters: CreateGamificationModelsIdSolveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SolveResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling createGamificationModelsIdSolve().'
            );
        }

        if (requestParameters['solveBody'] == null) {
            throw new runtime.RequiredError(
                'solveBody',
                'Required parameter "solveBody" was null or undefined when calling createGamificationModelsIdSolve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/gamification-models/{id}/solve`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SolveBodyToJSON(requestParameters['solveBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SolveResponseFromJSON(jsonValue));
    }

    /**
     * Submit a solution attempt for a CIPHER gamification model
     */
    async createGamificationModelsIdSolve(requestParameters: CreateGamificationModelsIdSolveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SolveResponse> {
        const response = await this.createGamificationModelsIdSolveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Spin on a WHEEL_SPIN or QUEST_ROULETTE gamification model
     */
    async createGamificationModelsIdSpinRaw(requestParameters: CreateGamificationModelsIdSpinRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WheelSpinResultResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling createGamificationModelsIdSpin().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/gamification-models/{id}/spin`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WheelSpinResultResponseFromJSON(jsonValue));
    }

    /**
     * Spin on a WHEEL_SPIN or QUEST_ROULETTE gamification model
     */
    async createGamificationModelsIdSpin(requestParameters: CreateGamificationModelsIdSpinRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WheelSpinResultResponse> {
        const response = await this.createGamificationModelsIdSpinRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Submit an entry to a SHOWCASE gamification model
     */
    async createGamificationModelsIdSubmitRaw(requestParameters: CreateGamificationModelsIdSubmitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShowcaseSubmitResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling createGamificationModelsIdSubmit().'
            );
        }

        if (requestParameters['showcaseSubmitBody'] == null) {
            throw new runtime.RequiredError(
                'showcaseSubmitBody',
                'Required parameter "showcaseSubmitBody" was null or undefined when calling createGamificationModelsIdSubmit().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/gamification-models/{id}/submit`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ShowcaseSubmitBodyToJSON(requestParameters['showcaseSubmitBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShowcaseSubmitResponseFromJSON(jsonValue));
    }

    /**
     * Submit an entry to a SHOWCASE gamification model
     */
    async createGamificationModelsIdSubmit(requestParameters: CreateGamificationModelsIdSubmitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShowcaseSubmitResponse> {
        const response = await this.createGamificationModelsIdSubmitRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Vote for an entry in a SHOWCASE or BRACKET_VOTE gamification model
     */
    async createGamificationModelsIdVoteRaw(requestParameters: CreateGamificationModelsIdVoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VoteResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling createGamificationModelsIdVote().'
            );
        }

        if (requestParameters['voteBody'] == null) {
            throw new runtime.RequiredError(
                'voteBody',
                'Required parameter "voteBody" was null or undefined when calling createGamificationModelsIdVote().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/gamification-models/{id}/vote`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: VoteBodyToJSON(requestParameters['voteBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VoteResponseFromJSON(jsonValue));
    }

    /**
     * Vote for an entry in a SHOWCASE or BRACKET_VOTE gamification model
     */
    async createGamificationModelsIdVote(requestParameters: CreateGamificationModelsIdVoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VoteResponse> {
        const response = await this.createGamificationModelsIdVoteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a gamification model (public — excludes DRAFT and ARCHIVED). Answers and unrevealed content are omitted.
     */
    async getGamificationModelsIdRaw(requestParameters: GetGamificationModelsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GamificationModelResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getGamificationModelsId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/gamification-models/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GamificationModelResponseFromJSON(jsonValue));
    }

    /**
     * Get a gamification model (public — excludes DRAFT and ARCHIVED). Answers and unrevealed content are omitted.
     */
    async getGamificationModelsId(requestParameters: GetGamificationModelsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GamificationModelResponse> {
        const response = await this.getGamificationModelsIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Resolve which spin wheel config the authenticated user will spin (routes prize-restricted users to the global wheel)
     */
    async getGamificationModelsIdMySpinWheelConfigIdRaw(requestParameters: GetGamificationModelsIdMySpinWheelConfigIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MySpinWheelConfigIdResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getGamificationModelsIdMySpinWheelConfigId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/gamification-models/{id}/my-spin-wheel-config-id`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MySpinWheelConfigIdResponseFromJSON(jsonValue));
    }

    /**
     * Resolve which spin wheel config the authenticated user will spin (routes prize-restricted users to the global wheel)
     */
    async getGamificationModelsIdMySpinWheelConfigId(requestParameters: GetGamificationModelsIdMySpinWheelConfigIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MySpinWheelConfigIdResponse> {
        const response = await this.getGamificationModelsIdMySpinWheelConfigIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get public segment display data for a spin wheel config (no probabilities)
     */
    async getGamificationModelsSpinWheelConfigConfigIdRaw(requestParameters: GetGamificationModelsSpinWheelConfigConfigIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SpinWheelConfigPublicResponse>> {
        if (requestParameters['configId'] == null) {
            throw new runtime.RequiredError(
                'configId',
                'Required parameter "configId" was null or undefined when calling getGamificationModelsSpinWheelConfigConfigId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/gamification-models/spin-wheel-config/{configId}`;
        urlPath = urlPath.replace(`{${"configId"}}`, encodeURIComponent(String(requestParameters['configId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SpinWheelConfigPublicResponseFromJSON(jsonValue));
    }

    /**
     * Get public segment display data for a spin wheel config (no probabilities)
     */
    async getGamificationModelsSpinWheelConfigConfigId(requestParameters: GetGamificationModelsSpinWheelConfigConfigIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SpinWheelConfigPublicResponse> {
        const response = await this.getGamificationModelsSpinWheelConfigConfigIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
